import { render, staticRenderFns } from "./UserSourceChannel.vue?vue&type=template&id=3be9ad19"
import script from "./UserSourceChannel.vue?vue&type=script&lang=js"
export * from "./UserSourceChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports